module.exports = __webpack_public_path__ + "img/justify-right.91443ec1.svg";